export enum SuitableVehicleSources {
  VehiclesByCode = 'Vehicles by code',
  VehiclesByModel = 'Vehicles by model',
  VehicleGroups = 'Vehicles groups',
}
